import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import RuleModalStore from '@src/business-components/rule-modal/store';
import Link from '@src/components/link';

const styles = require('./index.less');

/**
 * 分享弹窗
 * @param {CommonModalStore} store
 * @param onClose
 * @return {JSX.Element}
 * @constructor
 */
const RuleModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.ruleModalRoot)}>
        {/* <div className={styles.title} /> */}
        <Link className={styles.close} onClick={store.onClickClose} />
        <div className={styles.content}>
          <div className={styles.contentBox}>{store.text}</div>
        </div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(RuleModal, RuleModalStore);
